import fetch from '../../utils/fetch'

// export function getWxUserInfo(openid) {
//     return fetch({
//         url: '/api/verify/getWxUserInfo?openid=' + openid,
//         method: 'GET',
//     })
// }

export function getWxUserInfo(openid) {
    return fetch({
        url: '/api/verify/getWxUserInfo?openid=' + openid,
        method: 'GET',
    })
}
